import Metric from './Metric'

export default Metric
